import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import cc from 'classcat';
import { isRtl } from 'utils/constants/app/rtl';
import { mountPoint } from 'utils/generic/route-manipulation';
import { ENotRealSports } from 'interfaces/not-real-sports';
import { TTeam } from 'interfaces/sportsbook-data-levels';
import { TeamLogo } from 'components/TeamLogo';
import { useCustomHistory } from 'newhooks/generic/useCustomHistory';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { resetMarketTypes } from 'store/actions';
import { resetAdvancedSportsForMarketsTypes } from 'store/actions/new-sportsbook';
import './index.less';

if (isRtl) {
  import('./rtl.less');
}

export const FavoriteTeamSingleView: FC<
  TTeam & { withWidth?: boolean; activeStyles?: { withoutBorder?: boolean } }
> = ({ teamId, teamName, sport, withWidth, activeStyles }) => {
  const location = useLocation();
  const { push, history } = useCustomHistory();
  const dispatch = useDispatch();
  const routeMatch = useSbRouteMatch(
    `${mountPoint(location.pathname)}/team/:sport/:teamId?`
  );

  const isActive = routeMatch.params.teamId === `${teamId}`;

  const handleRedirect = () => {
    const redirectUrl = `${mountPoint(location.pathname)}/${
      ENotRealSports.team
    }/${sport.alias}/${teamId}`;

    if (
      location.pathname.includes(
        `${mountPoint(location.pathname)}/${ENotRealSports.team}`
      )
    ) {
      history.push(redirectUrl);
    } else {
      push(redirectUrl);
    }

    dispatch(resetAdvancedSportsForMarketsTypes());
    dispatch(resetMarketTypes());
  };

  return (
    <div
      className={cc([
        'favoriteTeamSingleView',
        {
          'favoriteTeamSingleView--active': isActive,
          'favoriteTeamSingleView--active--withoutBorder':
            isActive && activeStyles?.withoutBorder
        }
      ])}
      onClick={handleRedirect}
    >
      <div>
        <TeamLogo
          teamId={teamId}
          size="sm"
          className="favoriteTeamSingleView__headerIcon"
        >
          <span className="favoriteTeamSingleView__icon">
            {teamName.substring(0, 2).toUpperCase()}
          </span>
        </TeamLogo>
      </div>
      <div
        className={cc([
          'favoriteTeamSingleView__main',
          { 'favoriteTeamSingleView__main--withWidth': withWidth }
        ])}
      >
        <div
          title={teamName}
          className="favoriteTeamSingleView__main__teamName globalEllipsis"
        >
          {teamName}
        </div>
        <div className="favoriteTeamSingleView__main__sportName">
          {sport.name}
        </div>
      </div>
    </div>
  );
};
